import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { formatCurrencyValue } from 'utils/format';

import { FeesStepTestIds } from '../../FeesStep.testIds';

import {
  barStyles,
  highlightValueStyles,
  labelStyles,
  liveDotStyles,
  liveStyles,
  totalStyles,
} from './FeeTotalsBar.styles';

const FeeTotalsBar = ({ totals }) => {
  const { loanCosts, otherCosts, cashToClose } = totals;

  const items = [
    { key: 'loanCosts', label: 'Loan Costs (A+B+C)', value: loanCosts, highlight: false },
    { key: 'otherCosts', label: 'Other Costs (E+F)', value: otherCosts, highlight: false },
    { key: 'cashToClose', label: 'Est. Cash to Close', value: cashToClose, highlight: true },
  ];

  return (
    <Box data-testid={FeesStepTestIds.TOTALS_BAR} sx={barStyles}>
      {items.map(({ key, label, value, highlight }) => (
        <Box key={key} sx={totalStyles}>
          <Typography sx={labelStyles} variant="medium12">
            {label}
          </Typography>
          <Typography sx={highlight ? highlightValueStyles : undefined} variant="bold16">
            {formatCurrencyValue(value)}
          </Typography>
        </Box>
      ))}
      <Box sx={liveStyles}>
        <Box sx={liveDotStyles} />
        <Typography variant="regular12">Updates as you edit</Typography>
      </Box>
    </Box>
  );
};

FeeTotalsBar.propTypes = {
  totals: PropTypes.shape({
    loanCosts: PropTypes.number,
    otherCosts: PropTypes.number,
    cashToClose: PropTypes.number,
  }).isRequired,
};

export default memo(FeeTotalsBar);
